import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-07cf15d8")

_pushScopeId("data-v-07cf15d8")
const _hoisted_1 = {
  key: 0,
  class: "inline-flex"
}
const _hoisted_2 = {
  key: 1,
  class: "inline-flex"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("button", { class: "cursor-not-allowed text-white bg-gray-lp-600 px-8 text-12px xxl:text-14px py-2 xxl:py-3 font-bold rounded-md focus:outline-none" }, " Simpan ", -1)
const _hoisted_4 = { class: "px-6 w-6/12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_6 = { class: "px-6 w-full" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "flex flex-no-wrap font-semibold text-12px xxl:text-14px mb-6 pr-4" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-40" }, " Status Terakhir "),
  /*#__PURE__*/_createVNode("div", { class: "w-32" }, " Jumlah Refund "),
  /*#__PURE__*/_createVNode("div", { class: "w-24 mr-3" }, [
    /*#__PURE__*/_createTextVNode("Refund"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("Penalty (%)")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "w-48" }, " Perhitungan "),
  /*#__PURE__*/_createVNode("div", { class: "w-32" }, [
    /*#__PURE__*/_createTextVNode("Refund"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("Asuransi (%)")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "w-48" }, " Pengecualian Kota Asal ")
], -1)
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = {
  key: 0,
  class: "w-full bg-gray-lp-1000 p-3 mb-6"
}
const _hoisted_10 = { class: "w-40" }
const _hoisted_11 = { class: "w-24 mr-8" }
const _hoisted_12 = { class: "w-24 mr-3" }
const _hoisted_13 = { class: "w-48" }
const _hoisted_14 = { class: "w-32" }
const _hoisted_15 = { class: "w-64" }
const _hoisted_16 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_17 = { class: "px-6 w-6/12 pb-6" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Harga ", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Klik tombol dibawah untuk mengaktifkan pengaturan harga. ", -1)
const _hoisted_20 = { class: "flex flex-row pt-3 text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_22 = { class: "ml-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_city_exclude = _resolveComponent("city-exclude")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      loading: _ctx.isLoading,
      title: "Edit Configurable Price",
      "full-page": "",
      "vertical-separator": false
    }, {
      "top-right": _withId(() => [
        _createVNode("div", null, [
          (_ctx.isValidated)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode(_component_button_fill, {
                  onClick: _ctx.onOpenModalConfirmation,
                  title: "Simpan",
                  class: "px-8 bg-red-lp-300"
                }, null, 8, ["onClick"])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_2, [
                _hoisted_3
              ]))
        ])
      ]),
      data: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_DataWrapper, { label: "Nama Harga" }, {
            default: _withId(() => [
              _createVNode(_component_lp_input, {
                disabled: "",
                modelValue: _ctx.dataDetail.configurablePriceName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataDetail.configurablePriceName = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataDetail.configurableRefund, (configRefund, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: ["flex flex-no-wrap items-center border-t py-3", [{ 'px-2': !configRefund.refundRemarks }]]
            }, [
              _createVNode("div", _hoisted_8, [
                (!!configRefund.refundRemarks)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(configRefund.refundSttLastStatus), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(configRefund.remarks, (childConfig, i) => {
                  return (_openBlock(), _createBlock("div", {
                    key: `child-${i}`,
                    class: ["flex flex-row items-center", [
                { 'px-2': childConfig.refundRemarks },
                {
                  'config-child':
                    configRefund.remarks.length > 1 &&
                    i == configRefund.remarks.length - 1
                }
              ]]
                  }, [
                    _createVNode("div", _hoisted_10, _toDisplayString(childConfig.refundRemarks ?? childConfig.refundSttLastStatus), 1),
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_lp_input, {
                        format: _ctx.formatFloat,
                        modelValue: childConfig.refundAmount,
                        "onUpdate:modelValue": ($event: any) => (childConfig.refundAmount = $event),
                        error: 
                    _ctx.errorRefundAmount[
                      configRefund.remarks.length === 1 ? index : i
                    ]
                  ,
                        onChange: 
                    event =>
                      _ctx.validateRefundAmount(
                        event,
                        configRefund.remarks.length === 1 ? index : i
                      )
                  ,
                        placeholder: "e.g 20",
                        min: "0",
                        max: "100",
                        suffix: "%",
                        "error-icon": false
                      }, null, 8, ["format", "modelValue", "onUpdate:modelValue", "error", "onChange"])
                    ]),
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.calculateRefundPenalty(childConfig.refundAmount)), 1),
                    _createVNode("div", _hoisted_13, _toDisplayString(_ctx.refundQuantifierParser(childConfig.refundQuantifier)), 1),
                    _createVNode("div", _hoisted_14, _toDisplayString(childConfig.refundAmountInsurance), 1),
                    _createVNode("div", _hoisted_15, [
                      _createVNode(_component_city_exclude, {
                        modelValue: childConfig.refundOriginCityExcludeDetail,
                        "onUpdate:modelValue": ($event: any) => (childConfig.refundOriginCityExcludeDetail = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ], 2))
                }), 128))
              ])
            ], 2))
          }), 128))
        ]),
        _hoisted_16,
        _createVNode("div", _hoisted_17, [
          _hoisted_18,
          _hoisted_19,
          _createVNode("div", _hoisted_20, [
            _createVNode("div", {
              onClick: _cache[2] || (_cache[2] = () => _ctx.onOpenStatus()),
              class: 
              `toggle-switch inline-block cursor-pointer ${
                _ctx.isStatusActive
                  ? 'toggle-active bg-red-lp-100'
                  : 'bg-gray-lp-200'
              }`
            
            }, [
              _hoisted_21
            ], 2),
            _createVNode("div", _hoisted_22, _toDisplayString(_ctx.isStatusActive ? "Aktif" : "Tidak Aktif"), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "loading"]),
    _withDirectives(_createVNode(_component_Modal, {
      "on-close": _ctx.onCloseStatus,
      "on-submit": _ctx.changeStatus,
      title: _ctx.contentOpenStatus.title,
      message: _ctx.contentOpenStatus.message,
      image: _ctx.contentOpenStatus.image,
      textSuccess: _ctx.contentOpenStatus.button,
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["on-close", "on-submit", "title", "message", "image", "textSuccess"]), [
      [_vShow, _ctx.openStatus]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      "on-submit": _ctx.onCloseSuccess,
      title: "Perubahan Berhasil Disimpan !",
      message: 
      `Detail Harga “${_ctx.dataDetail.configurablePriceName}” berhasil diubah.`
    ,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["on-submit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      "on-submit": _ctx.handlerClose,
      "on-close": _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["on-submit", "on-close"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      "on-submit": _ctx.onEdit,
      "on-close": _ctx.onCloseModalConfirmation,
      title: "Konfirmasi Perubahan",
      message: 
      `Anda yakin ingin menyimpan perubahan detail Harga “${_ctx.dataDetail.configurablePriceName}” ?`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["on-submit", "on-close", "message"]), [
      [_vShow, _ctx.openModalConfirmation]
    ])
  ], 64))
})